'use client';

import React, { MouseEvent } from 'react';
import { useNavigateTab } from '@/features/tab/tab-history';
import { deserialize } from '@/entities/tab/model/path';
import { TabContext } from '@/entities/tab/model/tab.types';
import { useDockviewApi } from '@/app/providers/DockviewApiProvider';

interface IProps {
  to: string;
  onClick?: (e: MouseEvent<HTMLAnchorElement>) => void;
  children: React.ReactNode;
  style?: React.CSSProperties;
  className?: string;
}

export function TabLink({ to, onClick, children, style, className }: IProps) {
  const api = useDockviewApi();
  const { navigateTab } = useNavigateTab(api);

  const handleClick = (e: MouseEvent<HTMLAnchorElement>) => {
    const newContext = deserialize(to);
    const activePanel = api?.activePanel;

    if (e.ctrlKey || e.metaKey) {
      e.preventDefault();
      onClick?.(e);
      const { ...contextWithoutTabId } = newContext;
      delete contextWithoutTabId.tabId;
      navigateTab(contextWithoutTabId);
      return;
    }

    e.preventDefault();
    onClick?.(e);

    // URL에 tabId가 있으면 사용 (Autocomplete 포탈 등에서 activePanel이 null/잘못될 수 있음)
    if (!newContext.tabId && activePanel) {
      const activeContext = activePanel.params as TabContext;
      newContext.tabId = activeContext.tabId;
    }

    navigateTab(newContext);
  };

  return (
    <a
      href={to}
      onClick={handleClick}
      style={{ textDecoration: 'none', color: 'inherit', ...style }}
      className={className}
    >
      {children}
    </a>
  );
}
